import { Component, OnInit } from '@angular/core';
import {CategoryInfo} from "../models/categorymaster";
import {CategoryService} from "../services/category.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-categoryview',
  templateUrl: './categoryview.component.html',
})
export class CategoryviewComponent implements OnInit {

    categoryinfo:CategoryInfo;
    constructor(
        private categoryService:CategoryService,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.getCategoryInfo()
    }
    getCategoryInfo=function () {
        this.activatedRoute.params.subscribe(params => {
            let category_id = params['id'];
            console.log("CategoryId======>",category_id); // Print the parameter to the console.
            this.categoryService.getCategoryInfo(category_id).then(data => {
                console.log("CategoryInfo=======>",data['data']);
                this.categoryinfo = data['data'];
            });
        });

    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/categoriesmaster/categoryview/categoryview.component.ts